import { Box, styled, Typography } from "@mui/material";

export const HeaderBox = styled(Box) ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const HeaderTypography = styled(Typography) ({
  fontSize: 14,
  lineHeight: '24px',
  fontStyle: 'normal',
  fontWeight: 'medium',
})

export const HeaderSeparateTypography = styled(Typography) ({
  height: '14px',
  width: '2px',
  backgroundColor: '#E0E0E0',
})
